module.exports = __webpack_public_path__ + "static/media/Paper_Straws_SGS.9d088ed9.png";